import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { API, Auth } from 'aws-amplify';
import { COMPANIES_API_ENDPOINT, COMPANIES_API_NAME } from './app/core/companies.service';
import { COMPANY_CONTRACTS_API_ENDPOINT, COMPANY_CONTRACTS_API_NAME } from './app/core/company-contracts.service';
import { SELLERS_API_ENDPOINT, SELLERS_API_NAME } from './app/core/sellers.service';
import { SELLER_INVITATIONS_API_ENDPOINT, SELLER_INVITATIONS_API_NAME } from './app/core/seller-invitations.service';
import { STORES_API_ENDPOINT, STORES_API_NAME } from './app/core/stores.service';
import { ORDERS_API_ENDPOINT, ORDERS_API_NAME } from './app/core/orders.service';
import { BUYERS_API_ENDPOINT, BUYERS_API_NAME } from './app/core/buyers.service';
import { STEPS_API_ENDPOINT, STEPS_API_NAME } from './app/core/steps.service';
import { UNPAID_API_ENDPOINT, UNPAID_API_NAME } from './app/core/unpaid.service';
import { REPORTS_API_ENDPOINT, REPORTS_API_NAME } from './app/core/report.service';
import {
  COMPANY_QINETIC_PS_API_ENDPOINT,
  COMPANY_QINETIC_PS_API_NAME,
} from './app/core/company-qinetic-payment-source.service';
import {
  COMPANY_STRIPE_PS_API_ENDPOINT,
  COMPANY_STRIPE_PS_API_NAME,
} from './app/core/company-stripe-payment-source.service';
import { STORE_MEMBERSHIPS_API_ENDPOINT, STORE_MEMBERSHIPS_API_NAME } from './app/core/store-memberships.service';
import { QINETIC_IMPORT_API_ENDPOINT, QINETIC_IMPORT_API_NAME } from './app/core/qinetic-import.service';
import { QINETIC_POSITION_API_ENDPOINT, QINETIC_POSITION_API_NAME } from './app/core/qinetic-position.service';
import { DECIDO_EVALUATION_API_ENDPOINT, DECIDO_EVALUATION_API_NAME } from './app/core/decido-evaluation.service';
import { GARAN_LOG_API_ENDPOINT, GARAN_LOG_API_NAME } from './app/core/garan-log.service';
import { INTEGRATION_CALL_API_ENDPOINT, INTEGRATION_CALL_API_NAME } from './app/core/integration-call.service';
import {
  STORE_QINETIC_PS_API_ENDPOINT,
  STORE_QINETIC_PS_API_NAME,
} from './app/core/store-qinetic-payment-source.service';
import { LONG_RANGES_API_ENDPOINT, LONG_RANGES_API_NAME } from './app/core/long-range.service';
import {
  STRIPE_PAYMENT_SOURCES_API_ENDPOINT,
  STRIPE_PAYMENT_SOURCES_API_NAME,
} from './app/core/stripe-payment-sources.service';
import { REFUNDS_API_ENDPOINT, REFUNDS_API_NAME } from './app/core/refund.service';
import { SCRIPT_RUN_API_ENDPOINT, SCRIPT_RUN_API_NAME } from './app/core/script-run.service';
import {
  QINETIC_PAYMENT_SOURCES_API_ENDPOINT,
  QINETIC_PAYMENT_SOURCES_API_NAME,
} from './app/core/qinetic-payment-sources.service';
import { VOP_REQUEST_API_ENDPOINT, VOP_REQUEST_API_NAME } from './app/core/vop-request.service';
import {
  PRODUCT_CATEGORIES_API_ENDPOINT,
  PRODUCT_CATEGORIES_API_NAME,
} from './app/core/product-category.service';
import { CLUSTERS_API_ENDPOINT, CLUSTERS_API_NAME } from './app/core/cluster.service';

Auth.configure({
  Auth: {
    region: environment.USER_POOL_REGION,
    userPoolId: environment.USER_POOL_ID,
    userPoolWebClientId: environment.USER_POOL_WEB_CLIENT_ID,
    identityPoolId: environment.IDENTITY_POOL_ID,
    identityPoolRegion: environment.IDENTITY_POOL_REGION,
  },
});

API.configure({
  endpoints: [
    {
      name: COMPANIES_API_NAME,
      endpoint: COMPANIES_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: COMPANY_CONTRACTS_API_NAME,
      endpoint: COMPANY_CONTRACTS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: SELLERS_API_NAME,
      endpoint: SELLERS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: SELLER_INVITATIONS_API_NAME,
      endpoint: SELLER_INVITATIONS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: STORES_API_NAME,
      endpoint: STORES_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: ORDERS_API_NAME,
      endpoint: ORDERS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: BUYERS_API_NAME,
      endpoint: BUYERS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: STEPS_API_NAME,
      endpoint: STEPS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: UNPAID_API_NAME,
      endpoint: UNPAID_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: COMPANY_QINETIC_PS_API_NAME,
      endpoint: COMPANY_QINETIC_PS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: COMPANY_STRIPE_PS_API_NAME,
      endpoint: COMPANY_STRIPE_PS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: STORE_MEMBERSHIPS_API_NAME,
      endpoint: STORE_MEMBERSHIPS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: QINETIC_IMPORT_API_NAME,
      endpoint: QINETIC_IMPORT_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: QINETIC_POSITION_API_NAME,
      endpoint: QINETIC_POSITION_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: DECIDO_EVALUATION_API_NAME,
      endpoint: DECIDO_EVALUATION_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: GARAN_LOG_API_NAME,
      endpoint: GARAN_LOG_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: INTEGRATION_CALL_API_NAME,
      endpoint: INTEGRATION_CALL_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: STORE_QINETIC_PS_API_NAME,
      endpoint: STORE_QINETIC_PS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: LONG_RANGES_API_NAME,
      endpoint: LONG_RANGES_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: REPORTS_API_NAME,
      endpoint: REPORTS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: STRIPE_PAYMENT_SOURCES_API_NAME,
      endpoint: STRIPE_PAYMENT_SOURCES_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: REFUNDS_API_NAME,
      endpoint: REFUNDS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: SCRIPT_RUN_API_NAME,
      endpoint: SCRIPT_RUN_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: QINETIC_PAYMENT_SOURCES_API_NAME,
      endpoint: QINETIC_PAYMENT_SOURCES_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: VOP_REQUEST_API_NAME,
      endpoint: VOP_REQUEST_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: PRODUCT_CATEGORIES_API_NAME,
      endpoint: PRODUCT_CATEGORIES_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
    {
      name: CLUSTERS_API_NAME,
      endpoint: CLUSTERS_API_ENDPOINT,
      region: environment.USER_POOL_REGION,
    },
  ],
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
